import { Metadata } from 'next';
import { ReactNode } from 'react';

import { MismatchConfig, UpsellItemsConfiguration, UpsellModalComponentType } from '@app-types/eligibility/config';
import { PACK_HASH } from '@app-types/home-pack';
import { PageViewTrackingType } from '@app-types/tracking';

import { globalFaiUpsellConfig } from '@helpers/fai-upsell-config';
import { LegalsSlugType, PAGE_SLUG } from '@helpers/partials';

import { PlanTypeId } from '@constants/plan';
import { CATEGORY_TYPE, ELIGIBILITY_JOURNEY, TECHNOLOGY } from '@constants/provider';

export class EligibilityJourneyConfig {
    protected readonly name: ELIGIBILITY_JOURNEY = ELIGIBILITY_JOURNEY.DEFAULT;
    protected readonly seo: Metadata = {
        title: "Test d'éligibilité",
        robots: 'noindex, nofollow',
    };
    protected readonly tracking: PageViewTrackingType = {
        page: 'Eligibilite_test',
        pageCategory: 'Eligibilite',
        eCommerceStep: '',
        universe: 'Boutique_fai',
        marketLine: 'Fai',
        variant: {
            type_offres: 'Offres_Box',
        },
    };
    protected allowBox4g: boolean = false;
    protected fallbackMismatchOffers: PlanTypeId | null = null;
    protected readonly offerCategoryCodeToShow: PlanTypeId = PlanTypeId.FAI_ELIGIBILITE;
    protected readonly offerCategoryCodeToHide: PlanTypeId[] = [];
    protected readonly category: CATEGORY_TYPE = CATEGORY_TYPE.GP;
    protected readonly groupOffersBy: string[] = ['rangeNg', 'commercialSeries', 'play'];
    protected readonly showPackTabs: boolean = true;
    protected readonly isSingleOfferWording: boolean = false;

    protected readonly wordings: {
        mainTitle: ReactNode;
        noFiber: ReactNode;
    } = {
        mainTitle: 'On regarde les offres disponibles chez vous\u00A0?',
        noFiber: "En attendant l'arrivée de la fibre...",
    };
    protected readonly mismatch?: MismatchConfig = {
        title: 'Zut\u00A0! Ce logement ne semble éligible à aucune offre',
        showAddress: true,
        icon: 'tri-frown',
    };
    protected readonly legalsPath: LegalsSlugType = PAGE_SLUG.ELIGIBILITY;
    protected readonly productsToUpsell: UpsellItemsConfiguration[] = [
        {
            baseProduct: { rangeNg: 'xgbox', commercialSeries: 'medium_xgbox' },
            upselledProduct: { rangeNg: 'xgbox', commercialSeries: 'medium_tv_xgbox' },
            modalComponentType: UpsellModalComponentType.CLASSIC,
        },
    ];

    protected readonly technologies?: TECHNOLOGY[];
    protected readonly showComboProductSlug?: PACK_HASH[];
    protected readonly referrerConfigKey?: string;
    protected readonly cookieKey?: string;

    public getConfig() {
        return {
            name: this.name,
            wordings: this.wordings,
            seo: this.seo,
            tracking: this.tracking,
            allowBox4g: this.allowBox4g,
            offerCategoryCodeToShow: this.offerCategoryCodeToShow,
            fallbackMismatchOffers: this.fallbackMismatchOffers,
            offerCategoryCodeToHide: this.offerCategoryCodeToHide,
            category: this.category,
            groupOffersBy: this.groupOffersBy,
            showPackTabs: this.showPackTabs,
            isSingleOfferWording: this.isSingleOfferWording,
            mismatch: this.mismatch,
            legalsPath: this.legalsPath,
            productsToUpsell: [...globalFaiUpsellConfig, ...this.productsToUpsell],
            technologies: this.technologies,
            showComboProductSlug: this.showComboProductSlug,
            referrerConfigKey: this.referrerConfigKey,
            cookieKey: this.cookieKey,
        };
    }
}
